import React from 'react'
import Service from '../fetures/service-directory/Service'

const ServiceDirectoryPage = () => {
  return (
    <Service/>
  )
}

export default ServiceDirectoryPage